var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13H0.5V3L2 1.5L8 0.5L14 1.5L15.5 3V13Z",
    fill: "#00C2FF",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13C16 14.6569 12.4183 16 8 16C3.58172 16 0 14.6569 0 13C0 11.3431 3.58172 10 8 10C12.4183 10 16 11.3431 16 13Z",
    fill: "#00C2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7079 13.4195C14.4272 13.6683 13.964 13.9381 13.3057 14.185C11.9966 14.6759 10.121 15 8 15C5.87903 15 4.0034 14.6759 2.69427 14.185C2.03602 13.9381 1.57279 13.6683 1.29209 13.4195C1.01022 13.1696 1 13.0255 1 13C1 12.9745 1.01022 12.8304 1.29209 12.5805C1.57279 12.3317 2.03602 12.0619 2.69427 11.815C4.0034 11.3241 5.87903 11 8 11C10.121 11 11.9966 11.3241 13.3057 11.815C13.964 12.0619 14.4272 12.3317 14.7079 12.5805C14.9898 12.8304 15 12.9745 15 13C15 13.0255 14.9898 13.1696 14.7079 13.4195ZM8 16C12.4183 16 16 14.6569 16 13C16 11.3431 12.4183 10 8 10C3.58172 10 0 11.3431 0 13C0 14.6569 3.58172 16 8 16Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7079 3.41948C14.4272 3.66834 13.964 3.93815 13.3057 4.18499C11.9966 4.67591 10.121 5 8 5C5.87903 5 4.0034 4.67591 2.69427 4.18499C2.03602 3.93815 1.57279 3.66834 1.29209 3.41948C1.01022 3.16958 1 3.02553 1 3C1 2.97447 1.01022 2.83042 1.29209 2.58052C1.57279 2.33166 2.03602 2.06185 2.69427 1.81501C4.0034 1.32409 5.87903 1 8 1C10.121 1 11.9966 1.32409 13.3057 1.81501C13.964 2.06185 14.4272 2.33166 14.7079 2.58052C14.9898 2.83042 15 2.97447 15 3C15 3.02553 14.9898 3.16958 14.7079 3.41948ZM8 6C12.4183 6 16 4.65685 16 3C16 1.34315 12.4183 0 8 0C3.58172 0 0 1.34315 0 3C0 4.65685 3.58172 6 8 6Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.5V3H1V3.5H0ZM0 5.5V4.5H1V5.5H0ZM0 7.5V6.5H1V7.5H0ZM0 9.5V8.5H1V9.5H0ZM0 11.5V10.5H1V11.5H0ZM0 13V12.5H1V13H0Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.5V3H16V3.5H15ZM15 5.5V4.5H16V5.5H15ZM15 7.5V6.5H16V7.5H15ZM15 9.5V8.5H16V9.5H15ZM15 11.5V10.5H16V11.5H15ZM15 13V12.5H16V13H15Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtSolid);
export default __webpack_public_path__ + "static/media/ext-solid.a5e7182100fe2f903000ccc7f793864f.svg";
export { ForwardRef as ReactComponent };